module.exports = __webpack_public_path__ + "static/media/star-half-alt.981a565f.svg";